import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.12508 9.00002L12.0051 12.88L15.8851 9.00002C16.2751 8.61002 16.9051 8.61002 17.2951 9.00002C17.6851 9.39002 17.6851 10.02 17.2951 10.41L12.7051 15C12.3151 15.39 11.6851 15.39 11.2951 15L6.70508 10.41C6.51783 10.2232 6.4126 9.96954 6.4126 9.70502C6.4126 9.4405 6.51783 9.18685 6.70508 9.00002C7.09508 8.62002 7.73508 8.61002 8.12508 9.00002Z",
		fill: "currentColor"
	})
});
export default SvgArrowDown;
